import React from "react";
import EligibilityQuizPdf from "./EligibilityQuizPdf";

const Pdfs = ({ data, type }) => {
  return <>{type === "quiz" && <EligibilityQuizPdf data={data} />}</>;
};

export default Pdfs;
